import actions from './actions';
import mutations from './mutations';
import { ScheduledEmail } from './types';

const state = {
  emailTypes: [] as ScheduledEmail[],
  loadingEmailTypesList: false as boolean,
  loadingBulkUpdate: false as boolean,
  loadingSendTestEmail: false as boolean,
  loadingUpdateEmailType: false as boolean,
  loadingSendCustomEmail: false,
  emailInEdit: undefined as ScheduledEmail | undefined,
  emailTypesFor: '' as string
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
